module.exports = __webpack_public_path__ + "static/media/user_avatar.d7c2fe6f.svg";